import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main-maternite',
  imports: [RouterOutlet],
  templateUrl: './main-maternite.component.html',
  styleUrl: './main-maternite.component.scss'
})
export class MainMaterniteComponent {}
